import { render, staticRenderFns } from "./ProfitCategoryCard.vue?vue&type=template&id=556736ec&scoped=true&"
import script from "./ProfitCategoryCard.vue?vue&type=script&lang=js&"
export * from "./ProfitCategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfitCategoryCard.vue?vue&type=style&index=0&id=556736ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556736ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VRow})
